import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const BASE_URL = `https://v6.exchangerate-api.com/v6/3e06c69267239be3d3aaa35d/latest/`;

export const useExchangeRates = (base_code: string) => {
  return useQuery({
    queryKey: ['exchangeRates', base_code],
    queryFn: async () => {
      const { data } = await axios.get(`${BASE_URL}${base_code}`);
      console.log(data)
      return data.conversion_rates; 
    },
    staleTime: 1000 * 60 * 10, 
  });
};
